// TG homepage refresh code separated to remove from theme bundle
(function($) {
  var header = $('.site-header-wrapper'),
      displayOffset = 250,
      offset;

  header.on('mouseover', function() {
    header.addClass('is-over');
  })
  .on('mouseleave', function() {
    setTimeout(function() {
      header.removeClass('is-over');
    }, 400) // Magic number - grabbed from superstore.js ln#36455
  });

  // activateHeaderScrollClass();
  window.addEventListener('scroll', throttle(activateHeaderScrollClass, 250));


  // Announcement bar close
  $('[data-announcement-close]').on('click', function() {
    $('[data-announcement-bar]').hide();
  });

  // Learn videos
  if ($(".js-modal-btn").length > 0) {
    $(".js-modal-btn").modalVideo({
        channel: 'vimeo'
    });
  }

  // $('[data-navmenu-meganav-trigger]').addClass('open');
  // $('#shopify-section-static-basic-header').addClass('is-over');

  /**
   * Decide whether to activate header scroll class
   * depending on how far the viewport has been scrolled
   *
   * @return {void}
   */
  function activateHeaderScrollClass() {
    offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (offset > displayOffset) {
      header.addClass('has-scrolled');
    } else {
      header.removeClass('has-scrolled');
    }
  }

  function throttle(fn, wait) {
    var time = Date.now();

    return function() {
      if (time + wait - Date.now() < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  $(document).on('click', '.site-footer-block-content .footer-accordion-toggle', function(){

  	$(this).parent().toggleClass('accordion-expand');

  });

  if ($(window).width() < 1024) {
    $('#localization_form').appendTo('.device-location-form');
  }


})(jQuery);
